import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import type { KeyboardEvent, ReactNode } from 'react';
import { SecondaryMenuItemTitle } from './SecondaryMenuTitles';

type TextInputBoxSingleColProps = {
  inputRef?: React.Ref<any>;
  title?: string | ReactNode;
  descriptionText?: string;
  placeholderText?: string;
  onChange: (val: string) => void;
  onBlur?: (val: string) => void;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onPaste?: (val: string) => void;
  onKeyDown?: (event: KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  startAdornmentText?: string;
  endAdornmentText?: string;
  value?: string | number;
  error?: string;
  testId?: string;
  multiline?: boolean;
  minRows?: number;
};

export const TextInputBoxSingleCol = ({
  onChange,
  onBlur,
  onFocus,
  onPaste,
  onKeyDown,
  inputRef,
  title = 'title',
  descriptionText,
  placeholderText,
  startAdornmentText = '',
  endAdornmentText = '',
  value,
  error,
  testId,
  multiline,
  minRows,
}: TextInputBoxSingleColProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    onChange(newValue);
  };

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    if (!onBlur) return;
    const newValue = event.target.value;
    onBlur(newValue);
  };

  const handlePaste = (event: React.ClipboardEvent<HTMLDivElement>) => {
    if (!onPaste) return;
    const newValue = event.clipboardData.getData('text');
    onPaste(newValue);
  };

  const isError = !!error;

  return (
    <Grid container direction="column" rowGap={1}>
      <SecondaryMenuItemTitle>{title}</SecondaryMenuItemTitle>
      <Grid item width={'100%'} data-testid={testId}>
        <FormControl variant="outlined" size="small" color="secondary" fullWidth>
          <OutlinedInput
            inputRef={inputRef}
            type="text"
            multiline={multiline}
            minRows={minRows}
            onChange={handleChange}
            onBlur={handleBlur}
            onFocus={onFocus}
            onPaste={handlePaste}
            onKeyDown={onKeyDown}
            error={isError}
            value={value}
            placeholder={placeholderText}
            startAdornment={multiline ? undefined : <InputAdornment position="start">{startAdornmentText}</InputAdornment>}
            endAdornment={multiline ? undefined : <InputAdornment position="end">{endAdornmentText}</InputAdornment>}
          />
        </FormControl>
      </Grid>
      {descriptionText || error ? (
        <Box component="p" fontSize={12} lineHeight={1.5} letterSpacing={0.18} color={isError ? 'red' : '#353636'}>
          {isError ? error : descriptionText}
        </Box>
      ) : null}
    </Grid>
  );
};
